import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client from '../../api/client';
import Badge from '../../components/ui/Badge';
import Spinner from '../../components/ui/Spinner';
import { fechaCompleta, horaLegible } from '../../utils/fechas';
import { ListaReservas, Reserva, Detalle, Vacio } from './MisReservas';

const etiquetas = {
  asistio: { texto: 'Asististe', tono: 'exito' },
  falta: { texto: 'No asististe', tono: 'peligro' },
  reservada: { texto: 'Tomada', tono: 'arena' },
};

function Historial() {
  const [reservas, setReservas] = useState(null);

  useEffect(() => {
    client
      .get('/reservas/mias', { params: { historial: '1' } })
      .then(({ data }) => setReservas(data))
      .catch(() => setReservas([]));
  }, []);

  if (!reservas) return <Spinner />;

  if (reservas.length === 0) {
    return (
      <Vacio>
        Aún no has tomado clases. <Link to="/agenda">Reserva la primera</Link> y empieza tu
        práctica.
      </Vacio>
    );
  }

  return (
    <ListaReservas>
      {reservas.map((r) => {
        const etiqueta = etiquetas[r.estado] || etiquetas.reservada;
        return (
          <Reserva key={r.id}>
            <Detalle>
              <h3>{r.tipo_clase}</h3>
              <p>
                {fechaCompleta(r.fecha)} · {horaLegible(r.hora_inicio)} · {r.instructor}
              </p>
            </Detalle>
            <Badge $tono={etiqueta.tono}>{etiqueta.texto}</Badge>
          </Reserva>
        );
      })}
    </ListaReservas>
  );
}

export default Historial;
